import { SimulationMock } from '@/api/SimulationMock'
import { SimulationApi } from '@/api/Simulation'

export class SimulationRepository {
  static async create(simulationForm) {
    try {
      return SimulationApi.create(simulationForm)
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async getByConditionHash(conditionHash) {
    try {
      return SimulationApi.getByConditionHash(conditionHash)
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async getCsvByConditionHash(conditionHash, encode) {
    try {
      return SimulationApi.getCsvByConditionHash(conditionHash, encode)
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  static async getSimulationFromMock(simulationForm) {
    try {
      return SimulationMock.getSimulation(simulationForm)
    } catch (e) {
      console.error(e)
      throw e
    }
  }
}
